export default __webpack_public_path__ + "static/media/029-olive oil.4f10373b.svg";